import { Col, Container, Row } from "@crehana/ui";
import { useLearnLastActivityContext, useLearnLastActivityTranslations } from "../../hooks";
import CourseBannerSkeleton from "../CourseBanner/CourseBannerSkeleton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NewCoursesSliderSkeleton = function NewCoursesSliderSkeleton(_ref) {
  var className = _ref.className,
    dataTestId = _ref['data-testid'],
    showTitle = _ref.showTitle,
    withContainer = _ref.withContainer;
  var _useLearnLastActivity = useLearnLastActivityTranslations(),
    t = _useLearnLastActivity.t;
  var _useLearnLastActivity2 = useLearnLastActivityContext(),
    containerType = _useLearnLastActivity2.containerType,
    isDark = _useLearnLastActivity2.isDark;
  var renderSkeleton = function renderSkeleton(testId) {
    return /*#__PURE__*/_jsx(Row, {
      className: withContainer ? undefined : className,
      children: /*#__PURE__*/_jsx(Col, {
        xs: 12,
        children: /*#__PURE__*/_jsx(CourseBannerSkeleton, {
          isDark: isDark,
          "data-testid": testId
        })
      })
    });
  };
  return withContainer ? /*#__PURE__*/_jsxs(Container, {
    className: className,
    type: containerType,
    "data-testid": dataTestId,
    children: [showTitle && /*#__PURE__*/_jsx("h3", {
      className: "font-body3 text-base-lighter mb-16",
      children: t('NEW_COURSES_SLIDER_TITLE')
    }), renderSkeleton()]
  }) : renderSkeleton(dataTestId);
};
export default NewCoursesSliderSkeleton;